export const ToastMessages = {
  addFarmerRewards: 'Reward points added successfully',
  addLocationSuccess: 'Location added successfully',
  addSalespersonSuccess: 'Salesperson has been added successfully',
  addSubwalletSuccess: 'Subwallet added successfully',
  adminRetailerUploadLogoFailure: 'Oops! Something went wrong. We couldn’t upload your image.',
  adminRetailerUploadLogoSuccess: 'Your logo has been successfully uploaded!',
  deleteSalesPerson: 'Salesperson successfully deleted',
  farmersDeleteSuccess: 'Farmer removed',
  fileUploadSuccess: 'File Uploaded successfully',
  promotionCreated: 'Promotion created',
  promotionUpdated: 'Promotion updated',
  requestSubmitted: 'Request submitted successfully',
  retailerUpdated: 'Retailer updated',
  salesPersonCreateSuccess: 'Sales Person added',
  salesPersonUpdateSuccess: 'Sales Person updated',
  updateDefaultSalesPerson: 'Default sales person updated',
  updateFarmerRewards: 'Reward points updated successfully',
  updateLocationSuccess: 'Location updated successfully',
};

export const errorMessages = {
  imageTooLarge:
    'File size too large. Please upload an image under 5MB.',
  invalidImageType:
    'File format invalid. Allowed formats are PNG, SVG, and JPEG.',
  somethingWentWrong: 'Something went wrong, please try again later',
};

export const ConfirmationDialog = {
  activateLocationMessage: 'Are you sure you want to activate this Location?',
  activateMemberMessage: 'Are you sure you want to activate this member?',
  activateMemberTitle: 'Activate Member',
  activateRetailerMessage: 'Are you sure you want to activate this retailer?',
  activateLocationTitle: 'Activate Location',
  activateRetailerTitle: 'Activate Retailer',
  changeDefaultSalesPersonMessage: 'Are you sure you want to change the default salesperson?',
  changeDefaultSalesPersonTitle: 'Change Default Sales Person',
  deactivateMemberMessage: 'Are you sure you want to deactivate this member?',
  deactivateMemberTitle: 'Deactivate Member',
  deleteFarmerMessage: 'Are you sure you want to delete this farmer?',
  deleteFarmerTitle: 'Delete Farmer',
  deleteLocationLogoTitle: 'Delete Location Logo',
  deleteLocationLogoMessage: 'Are you sure you want to delete the Logo?',
  deleteMemberMessage: 'Are you sure you want to delete this member?',
  deleteMemberTitle: 'Delete Member',
  deleteSalesPersonMessage: 'Are you sure you want to delete this sales person?',
  deleteSalesPersonTitle: 'Delete Sales Person',
  inActivateManufacturerMessage: 'Are you sure you want to inactivate this manufacturer?',
  inActivateManufacturerTitle: 'Inactivate Manufacturer',
  inActivateRetailerMessage: 'Are you sure you want to deactivate this retailer?',
  inActivateRetailerTitle: 'Deactivate Retailer',
  inActivateLocationTitle: 'Deactivate Location',
  inActivateLocationMessage: 'Are you sure you want to deactivate this Location?',
  removeFarmerSalespersonMessage: `Are you sure you want to remove this salesperson from this product request?
  They will not be able to place an offer on the request. This action cannot be undone.`,
  removeFarmerSalespersonTitle: 'Remove Salesperson from Product Request',
};

export const AdminRetailerConstants = {
  addMemberSuccess: 'Member added successfully',
  addRetailerSuccess: 'Retailer added successfully',
  deleteMemberSuccess: 'Member deleted successfully',
  deleteMemberFailure: 'Something went wrong, please try again later',
  updateRetailerSuccess: 'Retailer updated successfully',
  updateMemberSuccess: 'Member updated successfully',
};

export const RetailerConstants = {
  defaultBrandColor: '#2a2a2a',
};

export const RewardsConstants = {
  addRewardsConfirmation: 'This action cannot be undone.',
  addRewardsDialogTitle: 'Update points',
  addRewardsMaxLimit: 99999.99,
  addRewardsMinLimit: 0.01,
};

export const CustomerChurn = {
  columns: {
    name: {
      label: 'Customer',
      key: 'name',
      width: '149px',
    },
    churnStatus: {
      label: 'Churn status',
      key: 'churnStatus',
      width: '180',
      description: 'This is the customer’s risk of churning status ' +
        '(potential to stop doing business with your retail organization) ' +
        'based on their activity over the past year. Customers with a transaction ' +
        'history of less than 1 year cannot be accurately assessed and will display ' +
        'with a status of ‘insufficient data`.',
    },
    rankCurrent: {
      label: 'Current status',
      key: 'rankCurrent',
      width: '171px',
      description: 'This is the current tier that the customer is' +
              'earning loyalty points at within the retailer rewards program',
    },
    rankEarned: {
      label: 'Re-earned tier',
      key: 'rankEarned',
      width: '170px',
      description: 'This is the tier that the customer has re-earned ' +
             'within the current rewards program period. The highest tier earned at the ' +
             'end of the current rewards program period will be the tier that the customer ' +
             'will start earning points at in the next program period.',
    },
    outstandingPointsIssued: {
      label: 'Outstanding issued points',
      key: 'outstandingPointsIssued',
      width: '149px',
    },
    accountGroupUsers: {
      label: 'Linked accounts',
      key: 'accountGroupUsers',
      width: '149px',
    },
  },
  filters: {
    'churnStatus': 'Churn status',
    'current-status': 'Current status',
    'customer': 'Customer',
    'location': 'Location',
    'salesperson': 'Salesperson',
  },
};
